!function(){"use strict";var t,e=function(t,e){return(e||document).querySelector(t)},a=function(t,e){return Array.prototype.slice.call((e||document).querySelectorAll(t))},n=window.WN&&window.WN.root||"/",r=!1;try{r=matchMedia("(prefers-reduced-motion: reduce)").matches}catch(D){}function i(t){var e=window.WN&&window.WN.money||"${{amount}}",a=(t/100).toFixed(2);return e.replace(/\{\{\s*(\w+)\s*\}\}/,function(e,n){return"amount_no_decimals"===n?Math.round(t/100).toString():"amount_with_comma_separator"===n?a.replace(".",","):a.replace(/\B(?=(\d{3})+(?!\d))/g,",")})}function s(a){var n=e("[data-toast]");n&&(n.textContent=a,n.classList.add("on"),clearTimeout(t),t=setTimeout(function(){n.classList.remove("on")},2400))}var o=e("[data-head]");o&&addEventListener("scroll",function(){o.classList.toggle("scrolled",scrollY>8)},{passive:!0});var c=e("[data-menu]");c&&c.addEventListener("click",function(){var t=e("#MobileNav").classList.toggle("on");c.setAttribute("aria-expanded",t)});/* cart drawer moved to wn-cart.js (window.WNCart); m() kept for the PDP add */function m(t){return window.WNCart&&window.WNCart.add?window.WNCart.add(t):Promise.reject(new Error("Cart is still loading. Try again."))}document.addEventListener("click",function(t){var n=t.target;if(n.closest){var l=n.closest("[data-dot]");if(l){var g=l.closest("[data-card]");a("[data-dot]",g).forEach(function(t){t.setAttribute("aria-pressed",t===l)});var y=e(".img1",g);y&&l.dataset.src&&(y.removeAttribute("srcset"),y.src=l.dataset.src);var b=e("[data-add]",g);b&&(b.dataset.add=l.dataset.id,b.hidden="true"!==l.dataset.avail)}}}),a(".card-media .img1").forEach(function(t){t.parentNode.querySelector(".img2")&&t.classList.add("has2")});var g=e("[data-sort]");if(g&&g.addEventListener("change",function(){var t=new URL(location.href);t.searchParams.set("sort_by",g.value),t.searchParams.delete("page"),location.href=t.toString()}),a("[data-lensdemo]").forEach(function(t){var a=e("input",t);function n(e){t.style.setProperty("--cut",e+"%")}if(a.addEventListener("input",function(){n(a.value)}),!r&&"IntersectionObserver"in window){var i=new IntersectionObserver(function(t){t.forEach(function(t){if(t.isIntersecting){i.disconnect();var e=null;!function t(r){null===e&&(e=r);var i=Math.min(1,(r-e)/1800),s=96+-58*(1-Math.pow(1-i,3));n(s),a.value=Math.round(s),i<1&&requestAnimationFrame(t)}(performance.now())}})},{threshold:.5});i.observe(t)}}),r&&a("[data-hero-ribbon]").forEach(function(t){try{t.setCurrentTime(6),t.pauseAnimations()}catch(t){}}),!r&&"IntersectionObserver"in window){var y=a(".reveal").filter(function(t){return t.getBoundingClientRect().top>innerHeight});y.forEach(function(t,e){t.classList.add("pre"),t.style.transitionDelay=e%4*80+"ms"});var b=new IntersectionObserver(function(t){t.forEach(function(t){t.isIntersecting&&(t.target.classList.remove("pre"),b.unobserve(t.target))})},{rootMargin:"0px 0px -8% 0px"});y.forEach(function(t){b.observe(t)})}}();
/* ===== Global chrome (agent D): header, menu drawer, search, countdowns, focus-reveal, intro veil =====
   Countdowns: [data-countdown="week|midnight|rolling:45|date:ISO"]; children [data-u=d|h|m|s] get units, else text.
   Focus reveal: add class .wn-focus to any element. Header height → --wn-header-h on <html>. */
!function(){"use strict";
  if (window.__wnChrome) return; window.__wnChrome = 1;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var doc = document.documentElement;
  var reduce = false; try { reduce = matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var WN = window.WN = window.WN || {};
  var pad = function (n) { return String(n).padStart(2, '0'); };

  /* intro veil cleanup (CSS also clears it with a forwards animation) */
  function endIntro() { doc.classList.remove('wn-intro', 'wn-soft'); var v = $('.wn-veil'); if (v) v.setAttribute('hidden', ''); }
  if (doc.classList.contains('wn-intro') || doc.classList.contains('wn-soft')) {
    setTimeout(endIntro, doc.classList.contains('wn-intro') ? 1300 : 400);
    setTimeout(endIntro, 2500);
  }

  /* overlay header: --wn-header-h / --wn-ann-h, glass→solid, announcement collapse */
  var head = $("[data-wn-head]"), top = $("[data-wn-top]") || (head && head.closest(".shopify-section")), ann = top && $(".ann", top);
  var design = doc.classList.contains("shopify-design-mode");
  if (top) document.body.classList.add("wn-has-overlay-header");
  function firstSection() { var m = $("main"); return m && m.firstElementChild; }
  function tone() {
    var fs0 = firstSection(); if (!fs0) return "light";
    var t = fs0.matches("[data-header]") ? fs0 : $("[data-header]", fs0);
    if (t) return t.getAttribute("data-header") === "dark" ? "dark" : "light";
    return $(".wn-bleed,.wn-under-header,[data-under-header]", fs0) ? "dark" : "light";
  }
  var headH = 0, annH = 0;
  function measure() {
    if (!top) return;
    headH = top.offsetHeight; annH = ann ? ann.offsetHeight : 0;
    doc.style.setProperty("--wn-header-h", headH + "px");
    doc.style.setProperty("--wn-ann-h", annH + "px");
  }
  var lastLive = -1, lastY = scrollY, ticking = false, isDark = tone() === "dark";
  function onScroll() {
    ticking = false; if (!top) return;
    var y = Math.max(0, scrollY), fs0 = firstSection();
    top.classList.toggle("is-scrolled", y > 8);
    var hero = fs0 && (fs0.matches("[data-header]") ? fs0 : $("[data-header],.wn-bleed,.wn-under-header,[data-under-header]", fs0)) || fs0;
    var heroEnd = isDark && hero ? hero.getBoundingClientRect().bottom + y - headH : 0;
    top.classList.toggle("is-glass", isDark && y < heroEnd);
    top.classList.toggle("is-solid", !(isDark && y < heroEnd));
    if (!design && ann) {
      var md0 = $("[data-wn-drawer].on");
      if (md0 || y < annH + 40 || y < lastY - 4) top.classList.remove("is-ann-hidden");
      else if (y > lastY + 4) top.classList.add("is-ann-hidden");
    }
    var live = (top.classList.contains("is-ann-hidden") ? headH - annH : headH);
    if (live !== lastLive) { lastLive = live; doc.style.setProperty("--wn-head-live", live + "px"); }
    lastY = y;
  }
  measure(); onScroll();
  addEventListener("resize", function () { measure(); onScroll(); }, { passive: true });
  addEventListener("load", function () { measure(); onScroll(); });
  if (top && "ResizeObserver" in window) new ResizeObserver(measure).observe(top);
  addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  document.addEventListener("shopify:section:load", function () { isDark = tone() === "dark"; measure(); onScroll(); });

  /* stripe draw-in: .wn-stripe-draw, .wn-stripe--sweep */
  (function () {
    var els = $$(".wn-stripe-draw,.wn-stripe--sweep");
    if (reduce || !("IntersectionObserver" in window)) { els.forEach(function (e) { e.classList.add("is-in"); }); return; }
    var io = new IntersectionObserver(function (en) { en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add("is-in"); io.unobserve(x.target); } }); }, { threshold: .2 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* cart pill: fallback when the cart script is not listening */
  document.addEventListener('click', function (e) {
    var c = e.target.closest('[data-wn-cart-open]');
    if (!c || e.defaultPrevented) return;
    if (!document.getElementById('CartDrawer')) return; // no drawer: follow the link to /cart
    e.preventDefault();
    if (window.WNCart && typeof WNCart.open === 'function') WNCart.open();
    else document.dispatchEvent(new CustomEvent('wn:cart:refresh', { detail: { open: true } }));
  });

  /* mobile menu drawer */
  var md = $('[data-wn-drawer]'), mbtn = $('[data-wn-menu]'), lastFocus = null;
  function openMenu() {
    if (!md) return; lastFocus = document.activeElement;
    md.removeAttribute('inert'); md.setAttribute('aria-hidden', 'false'); md.classList.add('on'); if (top) top.classList.remove('is-ann-hidden');
    doc.classList.add('wn-lock'); if (mbtn) mbtn.setAttribute('aria-expanded', 'true');
    setTimeout(function () { var f = $('.md-nav a', md); if (f) f.focus(); }, 80);
  }
  function closeMenu() {
    if (!md || !md.classList.contains('on')) return;
    md.classList.remove('on'); md.setAttribute('aria-hidden', 'true'); md.setAttribute('inert', '');
    doc.classList.remove('wn-lock'); if (mbtn) mbtn.setAttribute('aria-expanded', 'false');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (mbtn) mbtn.addEventListener('click', openMenu);
  document.addEventListener('click', function (e) { if (e.target.closest('[data-wn-menu-close]')) closeMenu(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeMenu(); closeSearch(); if (more && more.classList.contains('on')) { more.classList.remove('on'); } }
    if (e.key === 'Tab' && md && md.classList.contains('on')) {
      var f = $$('a[href],button', md); if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });
  addEventListener('resize', function () { if (innerWidth >= 1000) closeMenu(); }, { passive: true });

  /* predictive search overlay: /search/suggest.json, falls back to /search without JS */
  var sbtn = $('[data-wn-search-toggle]'), sbox = $('[data-wn-ps]'), sq = sbox && $('[data-wn-ps-q]', sbox), sres = sbox && $('[data-wn-ps-res]', sbox), sidle = sbox && $('[data-wn-ps-idle]', sbox), sT = 0, sCtl = null, sLast = '';
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  function money(cents) { var f = (WN.money || '${{amount}}'), a = (cents / 100).toFixed(2); return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) { return k === 'amount_no_decimals' ? Math.round(cents / 100).toString() : k === 'amount_with_comma_separator' ? a.replace('.', ',') : a.replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ','); }); }
  function openSearch() {
    if (!sbox) return; lastFocus = document.activeElement;
    sbox.hidden = false; void sbox.offsetWidth; sbox.classList.add('on'); doc.classList.add('wn-lock');
    if (sbtn) sbtn.setAttribute('aria-expanded', 'true'); if (top) top.classList.remove('is-ann-hidden');
    setTimeout(function () { sq && sq.focus(); }, 30);
  }
  function closeSearch() {
    if (!sbox || sbox.hidden) return;
    sbox.classList.remove('on'); doc.classList.remove('wn-lock'); if (sbtn) sbtn.setAttribute('aria-expanded', 'false');
    setTimeout(function () { sbox.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function renderSuggest(q, j) {
    var r = (j && j.resources && j.resources.results) || {}, ps = r.products || [], cs = r.collections || [], qs = r.queries || [], h = '';
    if (qs.length || cs.length) {
      h += '<div class="ps-chips">';
      qs.slice(0, 4).forEach(function (x) { h += '<a class="ps-chip is-q" href="' + esc(x.url) + '">' + esc(x.text) + '</a>'; });
      cs.slice(0, 3).forEach(function (x) { h += '<a class="ps-chip" href="' + esc(x.url) + '">' + esc(x.title) + '</a>'; });
      h += '</div>';
    }
    if (ps.length) {
      h += '<ul class="ps-list" role="list">';
      ps.forEach(function (x) {
        var pr = Math.round(parseFloat(x.price) * 100), cp = Math.round(parseFloat(x.compare_at_price_max || 0) * 100), img = x.featured_image && x.featured_image.url || x.image || '';
        if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        h += '<li><a class="ps-item" href="' + esc(x.url) + '"><span class="ps-img">' + (img ? '<img src="' + esc(img) + '" alt="" width="80" height="80" loading="lazy">' : '') + '</span><span class="ps-t"><b>' + esc(x.title) + '</b><span class="num">' + money(pr) + (cp > pr ? ' <s>' + money(cp) + '</s>' : '') + '</span></span><span class="ps-go" aria-hidden="true">→</span></a></li>';
      });
      h += '</ul>';
    }
    h += ps.length || qs.length || cs.length
      ? '<a class="ps-all" href="' + (WN.searchUrl || '/search') + '?type=product&q=' + encodeURIComponent(q) + '">See all results for “' + esc(q) + '” <span aria-hidden="true">→</span></a>'
      : '<p class="ps-none">No matches for “' + esc(q) + '”. Try a frame name or colour.</p>';
    sres.innerHTML = h; sres.hidden = false; sidle.hidden = true;
  }
  function suggest() {
    var q = sq.value.trim(); if (q === sLast) return; sLast = q;
    if (!q) { sres.hidden = true; sidle.hidden = false; return; }
    if (sCtl && sCtl.abort) sCtl.abort(); sCtl = 'AbortController' in window ? new AbortController() : null;
    fetch((WN.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last', { signal: sCtl && sCtl.signal })
      .then(function (r) { return r.json(); }).then(function (j) { if (sq.value.trim() === q) renderSuggest(q, j); }).catch(function () {});
  }
  if (sbtn && sbox) {
    sbtn.addEventListener('click', function (e) { e.preventDefault(); if (sbox.hidden) openSearch(); else closeSearch(); });
    sq.addEventListener('input', function () { clearTimeout(sT); sT = setTimeout(suggest, 180); });
    document.addEventListener('click', function (e) { if (e.target.closest('[data-wn-ps-close]')) closeSearch(); });
    document.addEventListener('keydown', function (e) { if (e.key === '/' && !/INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '') && sbox.hidden) { e.preventDefault(); openSearch(); } });
  }

  /* priority+ desktop nav: links that do not fit go into "More" (never overlaps the logo) */
  var nav = $('[data-wn-nav]'), more = nav && $('[data-wn-more]', nav);
  function fitNav() {
    if (!nav || !more) return;
    var items = $$(':scope > ul > li[data-i]', nav), copies = $$('.hd-more-list li', more);
    items.forEach(function (li) { li.hidden = false; }); copies.forEach(function (li) { li.hidden = true; }); more.hidden = true;
    if (!nav.offsetWidth) return;
    var ul = $(':scope > ul', nav), i = items.length - 1;
    while (ul.scrollWidth > nav.clientWidth + 1 && i > 0) {
      items[i].hidden = true; copies[i].hidden = false; more.hidden = false; i--;
    }
  }
  if (more) {
    var mb = $('button', more);
    mb.addEventListener('click', function () { var on = !more.classList.contains('on'); more.classList.toggle('on', on); mb.setAttribute('aria-expanded', String(on)); });
    document.addEventListener('click', function (e) { if (!e.target.closest('[data-wn-more]') && more.classList.contains('on')) { more.classList.remove('on'); mb.setAttribute('aria-expanded', 'false'); } });
    fitNav(); addEventListener('resize', fitNav, { passive: true }); addEventListener('load', fitNav);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
  }

  /* countdowns */
  function target(mode) {
    var now = Date.now(); mode = mode || 'week';
    if (mode.indexOf('rolling:') === 0) {
      var mins = parseFloat(mode.split(':')[1]) || 45, len = mins * 60000, key = 'w_cd_' + mins, start = 0;
      try { start = +localStorage.getItem(key) || 0; if (!start) { start = now; localStorage.setItem(key, start); } } catch (e) { start = now - (now % len); }
      return start + Math.ceil((now - start + 1) / len) * len;
    }
    if (mode.indexOf('date:') === 0) return new Date(mode.slice(5)).getTime();
    var d = new Date();
    if (mode === 'midnight') { d.setHours(24, 0, 0, 0); return d.getTime(); }
    if (mode === 'week10') {
      var mon = new Date(); mon.setDate(mon.getDate() - ((mon.getDay() + 6) % 7)); mon.setHours(0, 0, 0, 0);
      if (now < mon.getTime() + 600000) return mon.getTime();
      mon.setDate(mon.getDate() + 7); return mon.getTime();
    }
    d.setDate(d.getDate() + ((7 - d.getDay()) % 7)); d.setHours(24, 0, 0, 0); return d.getTime();
  }
  WN.countdownTarget = target;
  function tick() {
    $$('[data-countdown]').forEach(function (el) {
      var s = Math.max(0, Math.floor((target(el.getAttribute('data-countdown')) - Date.now()) / 1000));
      el.classList.toggle('is-ended', s === 0);
      var v = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
      var units = $$('[data-u]', el);
      if (units.length) {
        var hasD = units.some(function (u) { return u.getAttribute('data-u') === 'd'; });
        units.forEach(function (u) {
          var k = u.getAttribute('data-u'), n = k === 'h' && !hasD ? v.h + v.d * 24 : v[k];
          var t = k === 'd' || k === 'h' ? String(n) : pad(n);
          if (u.textContent !== t) { u.textContent = t; if (!reduce) { u.classList.remove('tick'); void u.offsetWidth; u.classList.add('tick'); } }
        });
      } else {
        el.textContent = v.d ? v.d + 'd ' + v.h + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's' : v.h ? v.h + 'h ' + pad(v.m) + 'm ' + pad(v.s) + 's' : v.m + 'm ' + pad(v.s) + 's';
      }
    });
  }
  tick(); setInterval(tick, 1000);

  /* focus reveal: .wn-focus (blur + rise → sharp) */
  function focusReveal() {
    var els = $$('.wn-focus:not([data-wn-seen])');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.setAttribute('data-wn-seen', ''); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.remove('pre'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el, i) {
      el.setAttribute('data-wn-seen', '');
      if (el.getBoundingClientRect().top < innerHeight) return; // already visible: never hide it
      el.classList.add('pre'); el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
  WN.focusReveal = focusReveal;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', focusReveal); else focusReveal();
  document.addEventListener('shopify:section:load', focusReveal);
  document.addEventListener('wn:cards', focusReveal);
}();
/* Redeemly "Store credits" launcher (app, open shadow DOM, inline styles): on-brand navy + smaller so it covers less.
   Only touches the floating button's inline style; if the app changes its markup this silently does nothing. */
!function(){"use strict";
  var tries = 0;
  function tune() {
    var h = document.getElementById('mcb-launcher-widget-root'), s = h && h.shadowRoot, b = s && s.querySelector('.launcher__floating-button');
    if (!b) { if (++tries < 20) setTimeout(tune, 1000); return; }
    var apply = function () {
      if (b.dataset.wn === '1' && b.style.backgroundColor === 'rgb(0, 0, 0)' && b.style.borderRadius === '0px') return;
      b.dataset.wn = '1';
      b.style.setProperty('background-color', '#000000', 'important');
      b.style.setProperty('padding', '2px 8px', 'important');
      b.style.setProperty('bottom', '14px', 'important');
      b.style.setProperty('left', '14px', 'important');
      b.style.setProperty('border-radius', '0', 'important');
      b.style.setProperty('box-shadow', 'none', 'important');
      b.style.setProperty('zoom', '.86');
      /* LUXE: keep it off the PDP gallery on desktop */
      if (document.body.classList.contains('wn-product') && innerWidth >= 990) b.style.setProperty('display', 'none', 'important'); else b.style.removeProperty('display');
    };
    apply();
    try { new MutationObserver(apply).observe(b, { attributes: true, attributeFilter: ['style'] }); } catch (e) {}
  }
  if (document.readyState === 'complete') setTimeout(tune, 800); else addEventListener('load', function () { setTimeout(tune, 800); });
}();
